/**
 * @author Hiroki Moto
 * @description https://xd.adobe.com/spec/12b34f37-4bc4-45ed-7e71-dcd9a54fa641-6482/screen/e264e544-0557-40d2-b820-21660b2afa70/Buttons/
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { pagination } from '~/services/util';

const Pagination = ({
    className = null,
    current = 1,
    per = 25,
    total = 2,
    size = 'small',
    pers = [25, 50, 'all'],
    suffix = '',
    dataCy = null,
    mountEvent = false,
    onChange = () => {},
    onPer = () => {},
}) => {
    const handleControl = (step) => () => {
        if ((current == total && step == 1) || (current == 1 && step == -1)) return;
        const page = current + step;

        if (page >= 1 && page <= total) {
            onChange(page);
        } else if (page < 1) {
            onChange(total);
        } else {
            onChange(1);
        }
    };

    const handlePage = (e) => () => {
        if (e == '...') return;
        const innerScroll = document.getElementById(dataCy);
        onChange(e);
        if (innerScroll) {
            innerScroll.scroll(0, 0);
        }
    };

    useEffect(() => {
        if (mountEvent) onChange(current);
    }, [mountEvent, onChange, current]);

    if (total < 2) return null;
    return (
        <div className={classNames('core-pagination', size, className)} data-cy={dataCy}>
            <div className="core-pagination-button ctl left" onClick={handleControl(-1)}>
                <span className={current == 1 ? 'disabled' : ''}>{`PREV ${suffix}`}</span>
            </div>
            {pagination(current, total).map((item, index) => {
                const page = classNames('core-pagination-button', { active: item == current });
                return (
                    <div className={page} key={`pg-${index}`} onClick={handlePage(item)}>
                        <span>{item}</span>
                    </div>
                );
            })}
            <div className="core-pagination-button ctl right" onClick={handleControl(1)}>
                <span className={current === total ? 'disabled' : ''}>{`NEXT ${suffix}`}</span>
            </div>

            {pers.length > 0 && (
                <div className="core-pagination-pers d-none d-md-flex ms-auto">
                    {pers.map((item) => {
                        const page = classNames('core-pagination-per', {
                            active: item == per || (item == 'all' && per == 5000),
                        });
                        const counts = item == 'all' ? 5000 : item;
                        return (
                            <div key={item}>
                                <span className={page} onClick={() => onPer(counts)}>
                                    {item}
                                </span>
                                {item !== 'all' && <span className="px-2">|</span>}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

Pagination.propTypes = {
    className: PropTypes.string,
    current: PropTypes.number,
    per: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    total: PropTypes.number,
    pers: PropTypes.arrayOf(PropTypes.any),
    size: PropTypes.oneOf(['small', 'large']),
    suffix: PropTypes.string,
    mountEvent: PropTypes.bool,
    onChange: PropTypes.func,
    onPer: PropTypes.func,
};

export default Pagination;
